import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    if (url.length > 1 && !url.endsWith('/')) {
      url += '/';
    }
    return super.parse(url);
  }

  override serialize(tree: UrlTree): string {
    let result = super.serialize(tree);
    if (result.length > 1 && !result.endsWith('/')) {
      result += '/';
    }
    return result;
  }
}
